var render, staticRenderFns
import script from "./GridList.global.vue?vue&type=script&lang=ts&"
export * from "./GridList.global.vue?vue&type=script&lang=ts&"
import style0 from "./GridList.global.vue?vue&type=style&index=0&id=cb24037c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb24037c",
  null
  
)

export default component.exports